import { ofType } from "redux-observable";
import { of } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectThemedEventNextBuildingBundle } from "../../../selectors/selectEventInfo";
import { actionOutskirtsBundleLoad } from "../../info/outskirts/actionOutskirtBundleLoad";
import { TypeActionThemedEvent } from "../actionThemedEvent";
export var epicThemedEventLoadBuilding = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionThemedEvent.LoadBuilding), switchMap(function (action) {
        var state = state$.value;
        var outskirtBundle = selectThemedEventNextBuildingBundle(state);
        return of(actionOutskirtsBundleLoad(outskirtBundle));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/themed-events/epics/epicThemedEventLoadBuilding.ts
// module id = 2424
// module chunks = 3